import { render, staticRenderFns } from "./ReassignOrderComponent.vue?vue&type=template&id=8590deec&"
import script from "./ReassignOrderComponent.vue?vue&type=script&lang=ts&"
export * from "./ReassignOrderComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ReassignOrderComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VTab,VTabItem,VTabs,VTabsItems})
